import { network } from './network';

export async function queryRechargePackage(opts) {
	const res = await network({
		url: '/api/v1/shop/gem_packages',
		method: 'post',
		params: {
			type: opts.type
		},
		headers: {
			token: opts.token,
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryBillList(opts) {
	const res = await network({
		url: '/api/v1/shop/bills',
		method: 'post',
		params: {
			page: opts.page,
			page_size: 20
		},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function createStripeOrder(opts) {
	const res = await network({
		url: '/api/v1/shop/stripe/create_order',
		method: 'post',
		params: {
			package_id: opts.package_id
		},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}


export async function createOrder(opts) {
	const res = await network({
		url: '/ai/api/v1/charge/order/create/usdt',
		method: 'post',
		params: {
			id: opts.id
		},
		headers: {
			token: opts.token
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

